export const changeHexBright = (color, percent) => {
    let usePound = false;
    if (color.startsWith('#')) {
        color = color.slice(1);
        usePound = true;
    }
    const number_ = Number.parseInt(color, 16);
    let r = (number_ >> 16) + percent;
    if (r > 255) {
        r = 255;
    }
    else if (r < 0) {
        r = 0;
    }
    let b = ((number_ >> 8) & 255) + percent;
    if (b > 255) {
        b = 255;
    }
    else if (b < 0) {
        b = 0;
    }
    let g = (number_ & 255) + percent;
    if (g > 255) {
        g = 255;
    }
    else if (g < 0) {
        g = 0;
    }
    return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
};
export const preventDefault = (event) => {
    event.preventDefault();
};
